module.exports = __webpack_public_path__ + "AnmolNikam-da9564e5.webp";